import $ from 'jquery';

(function () {
  'use strict';

  const $filters = $('[data-category-filter]');
  const $teasers = $('[data-teaser]');
  let selected = [];

  const exports = {
    initialize: function () {
      $filters.on('change', function () {
        const $input = $(this);
        const value = $input.attr('value');

        if ($input.is(':checked')) {
          if (selected.indexOf(value) === -1) {
            selected.push(value);
          }
        } else {
          selected = selected.filter(function(index) {
            return index !== value;
          });
        }

        if (selected.length === 0) {
          exports.reset();
          return;
        }

        exports.process();
      });
    },

    process: function () {
      $teasers.hide();

      let $filteredResults = $('[data-category]');
      $.each(selected, function () {

        $filteredResults = $filteredResults.filter(function () {
          let matched = false;
          const currentFilterValue = $(this).attr('data-category');

          if (selected.indexOf(currentFilterValue) !== -1) {
            matched = true;
          }

          return matched;
        });
      });

      $('[data-category]').hide().filter($filteredResults).show();
    },

    reset: function () {
      $('[data-category]').show();
      $teasers.show();
    }
  };

  exports.initialize();
})();
